import axiosInstance from '../config/axios.js';

const API_BASE = '/tank-cleanings';

const tankCleaningService = {
  // Get all tank cleanings with optional filters and pagination
  getAll: async (page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { page, per_page: perPage, ...params }
      : { all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all tank cleanings without pagination
  getAllCleanings: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get client published tank cleanings (for clients)
  getClientCleanings: async (clientId, page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      client_id: clientId,
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/client`, { params: queryParams });
    return response.data;
  },

  // Get tank cleaning by ID
  getById: async (cleaningId) => {
    const response = await axiosInstance.get(`${API_BASE}/${cleaningId}`);
    return response.data;
  },

  // Create new tank cleaning
  create: async (cleaningData) => {
    const response = await axiosInstance.post(API_BASE, cleaningData);
    return response.data;
  },

  // Update tank cleaning
  update: async (cleaningId, cleaningData) => {
    const response = await axiosInstance.put(`${API_BASE}/${cleaningId}`, cleaningData);
    return response.data;
  },

  // Toggle published status
  togglePublished: async (cleaningId) => {
    const response = await axiosInstance.patch(`${API_BASE}/${cleaningId}/toggle-published`);
    return response.data;
  },

  // Delete tank cleaning
  delete: async (cleaningId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${cleaningId}`);
    return response.data;
  },

  // Generate certificate
  generateCertificate: async (cleaningId) => {
    const response = await axiosInstance.get(`${API_BASE}/${cleaningId}/certificate`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Toggle send_to_dm status
  toggleSendToDM: async (cleaningId) => {
    const response = await axiosInstance.patch(`${API_BASE}/${cleaningId}/toggle-send-to-dm`);
    return response.data;
  },

  // Get pending cleanings for DM
  getPendingForDM: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/pending-for-dm`, { params: queryParams });
    return response.data;
  },

  // Send bulk email for selected cleanings
  sendBulkEmail: async (cleaningIds) => {
    const response = await axiosInstance.post(`${API_BASE}/send-bulk-email`, {
      ids: cleaningIds
    });
    return response.data;
  },

  // Download bulk PDFs for selected cleanings (single PDF or ZIP)
  downloadBulkPDF: async (cleaningIds) => {
    const response = await axiosInstance.post(`${API_BASE}/bulk-pdf-download`, {
      ids: cleaningIds
    }, {
      responseType: 'blob'
    });
    return response;
  },

  // Export CSV for selected cleanings
  exportCSV: async (cleaningIds) => {
    const response = await axiosInstance.post(`${API_BASE}/export-csv`, {
      ids: cleaningIds
    }, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Duplicate a tank cleaning record
  duplicate: async (cleaningId) => {
    const response = await axiosInstance.post(`${API_BASE}/${cleaningId}/duplicate`);
    return response.data;
  },
};

export default tankCleaningService;